import { createContext } from 'react';
import { observer } from 'mobx-react-lite';
import { AppStore } from 'app.store';

export const AppContext = createContext(new AppStore());

export const AppContextProvider = observer<any>(({ children, appStore }: { children: any, appStore: AppStore }) => (
  <AppContext.Provider value={appStore}>{children}</AppContext.Provider>
));